import React from "react";

const NotFound = props => (
  <div>
    <h2>Sorry! Nothing here!</h2>
  </div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js